/** Ventana en la que una ubicación reportada se considera "viva". */
export const LIVE_LOCATION_WINDOW_MIN = 15;

/**
 * ¿La última ubicación del técnico es RECIENTE? (pin que palpita en el mapa).
 * PURO: `nowMs` inyectable para tests. Fechas inválidas o nulas → false.
 */
export function isLocationLive(
  lastLocationAt: string | null | undefined,
  nowMs: number = Date.now(),
  windowMin: number = LIVE_LOCATION_WINDOW_MIN,
): boolean {
  if (!lastLocationAt) return false;
  const t = new Date(lastLocationAt).getTime();
  if (Number.isNaN(t)) return false;
  const age = nowMs - t;
  return age >= 0 && age <= windowMin * 60_000;
}
